import Class from './c-data-tab';
import './c-data-tab@.vue';

export default Class;